import Vue from 'vue'
import VueNoty from 'vuejs-noty'
import App from './App.vue'
import ToggleButton from 'vue-js-toggle-button';
import vSelect from 'vue-select'
import {OSMAviation} from '../packages/styleguide'
import TopNavBar from './components/TopNavBar.vue'
import AppIcon from './components/AppIcon.vue'
import AppMenu from './components/AppMenu.vue'
import FormGroup from './components/FormGroup.vue'
import Datepicker from './components/Datepicker'
import Timepicker from './components/Timepicker'
import TimeField from './components/TimeField.vue'
import Address from './components/Address.vue'
import FileField from './components/FileField.vue'
import pendingApi from './pendingApi'
import Icon from './components/Icon.vue'
import router from './router'
import errors from './errors'
import store from './store'
import api from './api'
import menu from './menu'
import './registerServiceWorker'
import '../packages/styleguide/scss/_main.scss'
import 'vuejs-noty/dist/vuejs-noty.css'
import VueSweetAlert from 'vue-sweetalert'
import 'formdata-polyfill'
import './assets/scss/app.scss'
import {mapState} from 'vuex'
import Empty from '@/components/Empty.vue'
import TruncateText from '@/components/TruncateText'
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';
import globalMixin from './global';
import translations from './translations';

// polyfills
import '@babel/polyfill';
import './polyfills/MouseEvent';

Vue.config.productionTip = false;

Vue.use(VueNoty, {
    timeout: 2000,
    progressBar: false,
    layout: 'topRight',
    theme: 'osm'
});
Vue.use(OSMAviation);
Vue.use(pendingApi);
Vue.use(api);
Vue.use(ToggleButton);
Vue.use(VueSweetAlert);
Vue.use(VueCroppie);

Vue.mixin(globalMixin);
Vue.mixin(translations);

Vue.component('form-group', FormGroup);
Vue.component('app-icon', AppIcon);
Vue.component('app-menu', AppMenu);
Vue.component('top-nav-bar', TopNavBar);
Vue.component('datepicker', Datepicker);
Vue.component('timepicker', Timepicker);
Vue.component('time-field', TimeField);
Vue.component('address-field', Address);
Vue.component('file-field', FileField);
Vue.component('icon', Icon);
Vue.component('v-select', vSelect);
Vue.component('empty', Empty);
Vue.component('truncate-text', TruncateText);

const app = new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        let scriptTerms = document.createElement('script');
        scriptTerms.setAttribute("id", "locale-script");
        scriptTerms.setAttribute("type", "text/javascript");
        scriptTerms.setAttribute('src',process.env.VUE_APP_PORTAL + "/javascript/terms.js");
        document.head.appendChild(scriptTerms);
    },
    computed: {
        ...mapState(['notifications', 'apps']),
        menuItems() {
            return menu.map(item => {
                if (item.subItems.length) {
                    item.click = (e) => {
                        this.$children[0].$refs[item.label][0].toggle();
                    };
                } else {
                    item.click = false;
                }

                let id = item.route.substr(1).replace('/', '-');
                item.badge = this.notifications.filter(n => n.data.type === id).length;

                return item;
            })
        },
    },
    methods:
        {
            handleError(error) {
                errors(this, error);
            }
        }
}).$mount('#app');


router.beforeEach(function (to, from, next) {
    let menuItem = app.menuItems.find(item => item.route === to.path);
    if (!menuItem) {
        if (to.name === 'notifications') {
            app.$children[0].$refs.notifications.open();
            return next(false);
        }
        return next();
    }

    if (menuItem.click) {
        menuItem.click();
        app.$children[0].$refs.navigation.close();
        return next(false);
    }

    return next();

});
